








































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import moment from "moment";
import { formatCurrency } from "@/shared/currency";
import InvestmentTransferHistoryWidget from "@/shared/components/investments/InvestmentTransferHistoryWidget.vue";
import { useInvestmentDailyBalanceStore } from "@/shared/store/investmentDailyBalance";
import { useHsaDailyBalanceStore } from "@/shared/store/hsaDailyBalance";


@Component({
  components: {
    InvestmentTransferHistoryWidget
  }
})
export default class TdaInvestmentAccountPage extends Vue {
  formatCurrency = formatCurrency;
  investmentDailyBalanceStore = useInvestmentDailyBalanceStore();
  hsaDailyBalanceStore = useHsaDailyBalanceStore();

  @Prop() page: number;

  @Prop() routeToPages: (page: number) => Location;

  @Prop({ required: false }) username: string;

  @Prop({ required: false }) partnerId: number;

  mounted () {
    this.investmentDailyBalanceStore.loadCurrentDailyBalance({ username: this.username, partnerId: this.partnerId });
    this.hsaDailyBalanceStore.loadBalanceOnFile({ username: this.username, partnerId: this.partnerId });
  }

  get isLoaded () {
    return (
        this.investmentDailyBalanceStore.currentBalanceIsLoaded &&
        this.hsaDailyBalanceStore.balanceOnFileLoaded
    );
  }

  get investmentAccountBalance () {
    return formatCurrency(this.investmentDailyBalanceStore.tdaCurrentBalance.balance);
  }

  get investmentCashAmount () {
    return formatCurrency(this.investmentDailyBalanceStore.tdaCurrentBalance.cashPositionBalance);
  }

  get accountRetrievalDate () {
    return moment(this.investmentDailyBalanceStore.tdaCurrentBalance.date).format(
        "MMM D, YYYY"
    );
  }
}
